import type { TrainerCapability } from '@zeus/index'

export type Grants = Partial<Record<TrainerCapability, boolean>>
export type Dependencies = Partial<Record<TrainerCapability, readonly TrainerCapability[]>>

/** Toutes les capacités qu'une capacité suppose, de proche en proche. */
function requirementsOf(capability: TrainerCapability, dependencies: Dependencies): Set<TrainerCapability> {
  const found = new Set<TrainerCapability>()
  const pending = [...(dependencies[capability] ?? [])]
  for (let next = pending.pop(); next; next = pending.pop()) {
    if (found.has(next)) continue
    found.add(next)
    pending.push(...(dependencies[next] ?? []))
  }
  return found
}

/**
 * Coche ou décoche une capacité sans jamais laisser l'écran dans un état que
 * l'API refuserait (#11) : la cocher coche ce qu'elle suppose, la décocher
 * décoche ce qui la suppose. L'admin voit l'effet avant d'enregistrer.
 */
export function setGrant(
  grants: Grants,
  dependencies: Dependencies,
  capability: TrainerCapability,
  granted: boolean,
): Grants {
  const next: Grants = { ...grants, [capability]: granted }
  if (granted) {
    for (const required of requirementsOf(capability, dependencies)) next[required] = true
  } else {
    for (const dependent of Object.keys(dependencies) as TrainerCapability[]) {
      if (requirementsOf(dependent, dependencies).has(capability)) next[dependent] = false
    }
  }
  return next
}
